<app-table
    #currencyTable
    [gridData]="store.data.getCurrencies()"
    [columns]="columns"
    [refreshCallback]="store.api.getCurrencies"
    [refreshCallbackFragment]="currencyFrag"
    [additionalFilter]="filters()"
    [defaultSorters]="[{ column: 'code', direction: 'ASC' }]"
    [translatePrefix]="prefix"
    [tableTitle]="prefix + 'labelMulti'"
    [hideCheckboxes]="true"
    [showDelete]="store.isAllowed('madoAccount.update')()"
    [showDetail]="store.isAllowed('madoAccount.update')()"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
    (deleteCallbackWithEvent)="deleteItem($event)"
>
    <ng-template pTemplate="isDefault" let-data="data">
        <app-check-or-cross [value]="data"></app-check-or-cross>
    </ng-template>
</app-table>
